import { derived } from 'svelte/store';
import { scrollState } from './scroll-state-store';
import { mobileCtaSubnavMenuStateStore } from './mobile-cta-subnav-stores';
import { GLOBAL_NAV_MOBILE_IN_VIEW_OFFSET } from '../constants';
// global nav is sticky when scrolling up, page top global nav is not in view, and no CTA nav links (cta subnav without content)
export const mobileNavIsSticky = derived([scrollState, mobileCtaSubnavMenuStateStore], ([$scrollState, $mobileCtaSubnavMenuState]) => $scrollState.direction === 'up' &&
    $scrollState.offsetY > GLOBAL_NAV_MOBILE_IN_VIEW_OFFSET &&
    $mobileCtaSubnavMenuState.hasNavLinks === false);
